import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalEmptyAddressesService } from './service/modal-empty-addresses.service';
import { ModalViewLocationService } from '../modal-view-location/service/modal-view-location.service';

@Component({
  selector: 'app-modal-empty-addresses-user',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-empty-addresses-user.component.html',
  styleUrl: './modal-empty-addresses-user.component.css'
})
export class ModalEmptyAddressesUserComponent {
  constructor(
    public modalEmptyAddressesService: ModalEmptyAddressesService,
    private modalViewLocationService: ModalViewLocationService
  ) {}

  closeModal(): void {
    this.modalEmptyAddressesService.toggleModal(false);
  }

  openAddressModal(): void {
    // Cerrar el modal de direcciones vacías
    this.modalEmptyAddressesService.toggleModal(false);

    // Abrir el modal de selección de ubicación
    this.modalViewLocationService.toggleModal(true);
  }
}
